import styled from 'styled-components';
const ChangeIntegralStyled = styled.div`
  /* border: 1px solid red; */
  .MuiIconButton-root {
    width: 16px;
    height: 16px;
  }
  .MuiSvgIcon-root {
    fill: ${(props) => props.opt === 'preview' && '#c3c3c3'};
  }

  height: 100%;
  background-color: #fff;
  border-radius: 14px;
  padding: 8px 8px 32px;
  display: flex;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
  .second-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    .tab-content-wrapper {
      flex: 1;
      /* border: 1px solid green; */
      .tab-content {
        height: 100%;
        /* border: 1px solid orange; */
        .content-wrapper {
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow-y: hidden;
          padding-bottom: 8px;
          /* border: 2px solid purple; */
        }
      }
    }
  }
  .table-wrapper {
    /* border: 1px solid blue; */
    max-height: 500px;
    overflow-y: auto;
    margin-bottom: 12px;
  }
  .dfirRY {
    /* width: 1640px; */
    /* border: 1px solid red; */
  }
  .MuiTabs-root {
    height: 54px;
    margin-left: 24px;
    margin-right: 24px;
    border-bottom: 1px solid #f5f5f5;
    .MuiButtonBase-root {
      height: 52px;
      width: 160px;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .date-wrapper {
    display: flex;
    flex-direction: column;
  }
  .handle_btn {
    padding: 0 24px;
    justify-content: center;
    display: flex;

    .no-drop {
      cursor: not-allowed;
    }

    > div {
      margin-right: 15px;
    }
    span {
      font-size: 16px;
      /* color: #fff; */
    }
    .icon {
      width: 18px;
      height: 18px;
      fill: '#BDBDBD';
      > svg {
        border: 1px solid red;
      }
    }
    .MuiButtonBase-root {
      height: 40px;
      width: 40px;
    }

    .preview {
      cursor: pointer;
    }
    .canClick {
      cursor: pointer;
    }
    img {
      width: 18px;
      height: 18px;
    }
  }
  .MuiSvgIcon-root {
    color: ${(props) => props.theme.palette.primary.main};
  }
  .row {
    padding-left: 32px;
    > div {
      width: 360px;
    }
  }
  .css-1q60rmi-MuiAutocomplete-endAdornment {
    display: flex;
    /* .MuiIconButton-root {
      width: 16px;
      height: 16px;
    }
    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    } */
  }
  .text-input-align-style input {
    text-align: right;
  }
`;

export default ChangeIntegralStyled;
